(function () {
  if (!window.CfonElements) return;

  class CfonTabs extends CfonElements.Component {
    onConnect() {
      this.items = [];
      this.build();
    }

    onDisconnect() {
      this.teardown();
      this.items = [];
    }

    teardown() {
      this.items.forEach((item) => {
        if (!item.label || item.isLink) return;
        item.label.removeEventListener('click', item.clickHandler);
        item.label.removeEventListener('keydown', item.keydownHandler);
      });
    }

    build() {
      this.teardown();
      const roots = [
        ...this.querySelectorAll(':scope > [data-cfon-tab], :scope > .cfon-tab'),
      ];

      this.items = roots.map((root, index) => {
        const label = root.querySelector('[data-tab-label]');
        const panel = root.querySelector('[data-tab-panel]');
        const control = label
          ? label.querySelector('a[href], button') || label.firstElementChild
          : null;
        const isLink = Boolean(
          control && control.tagName === 'A' && control.getAttribute('href')
        );
        const openByDefault =
          !isLink && root.getAttribute('data-open-by-default') === 'true';

        if (label) {
          if (isLink) {
            label.setAttribute('data-tab-link', 'true');
            label.removeAttribute('role');
            label.removeAttribute('aria-selected');
            label.removeAttribute('aria-controls');
            label.removeAttribute('tabindex');
            label.classList.remove('is-active');
          } else {
            label.removeAttribute('data-tab-link');
            label.setAttribute('role', 'tab');
            label.id = label.id || `cfon-tab-label-${this.id || 'tabs'}-${index}`;
            if (panel) {
              panel.id = panel.id || `cfon-tab-panel-${this.id || 'tabs'}-${index}`;
              label.setAttribute('aria-controls', panel.id);
              panel.setAttribute('role', 'tabpanel');
              panel.setAttribute('aria-labelledby', label.id);
            }
          }
        }

        if (panel && isLink) {
          panel.hidden = true;
          panel.setAttribute('hidden', '');
        }

        const item = {
          root,
          label,
          panel,
          isLink,
          openByDefault,
          clickHandler: null,
          keydownHandler: null,
        };

        if (label && !isLink) {
          item.clickHandler = (event) => this.onLabelClick(event, item);
          item.keydownHandler = (event) => this.onLabelKeydown(event, item);
          label.addEventListener('click', item.clickHandler);
          label.addEventListener('keydown', item.keydownHandler);
        }

        return item;
      });

      this.setAttribute('role', 'tablist');
      if (!this.getAttribute('aria-label')) {
        this.setAttribute('aria-label', 'Tabs');
      }

      let initial = this.items.findIndex((item) => item.openByDefault);
      if (initial < 0) {
        initial = this.items.findIndex((item) => !item.isLink && item.panel);
      }

      if (initial >= 0) {
        this.activate(initial);
      } else {
        this.items.forEach((item) => {
          if (item.panel) {
            item.panel.hidden = true;
            item.panel.setAttribute('hidden', '');
          }
          if (item.label && !item.isLink) {
            item.label.classList.remove('is-active');
            item.label.setAttribute('aria-selected', 'false');
            item.label.tabIndex = -1;
          }
        });
      }
    }

    onLabelClick(event, item) {
      if (item.isLink) return;
      event.preventDefault();
      const index = this.items.indexOf(item);
      if (index < 0) return;
      this.activate(index);
    }

    onLabelKeydown(event, item) {
      if (item.isLink) return;
      const switchable = this.items
        .map((entry, index) => ({ entry, index }))
        .filter(({ entry }) => !entry.isLink && entry.label);
      if (!switchable.length) return;

      const current = switchable.findIndex(({ entry }) => entry === item);
      if (current < 0) return;

      let next = current;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = (current + 1) % switchable.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = (current - 1 + switchable.length) % switchable.length;
      } else if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = switchable.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      this.activate(switchable[next].index);
      switchable[next].entry.label.focus();
    }

    activate(index) {
      this.items.forEach((item, i) => {
        const active = i === index && !item.isLink;
        if (item.panel) {
          if (item.isLink || !active) {
            item.panel.hidden = true;
            item.panel.setAttribute('hidden', '');
          } else {
            item.panel.hidden = false;
            item.panel.removeAttribute('hidden');
          }
        }
        if (!item.label || item.isLink) return;
        item.label.classList.toggle('is-active', active);
        item.label.setAttribute('aria-selected', active ? 'true' : 'false');
        item.label.tabIndex = active ? 0 : -1;
      });
    }
  }

  CfonElements.define('cfon-tabs', CfonTabs);
})();
